import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import About from "./sections/About";
import OurMission from "./sections/OurMission";
import LeadershipTeam from "./sections/LeadershipTeam";
import InvestmentPhilosophy from "./sections/InvestmentPhilosophy";
import Contact from "./sections/Contact";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <About />
      <OurMission />
      <LeadershipTeam />
      <InvestmentPhilosophy />
      <Contact />
      <Footer />
    </div>;
}